import { createRestDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { toCamel, toSnake, transformQueryParamsWithoutLocale } from "@shared/utils";
import { Kh_Cities } from "@sisnaker-react-core/karirhub-model-type";
import { useQuery } from "@tanstack/react-query";

export function useCities({
  keyword,
  provinceIds,
  page = 1,
  limit = 10,
  enabled = true,
}: {
  keyword: string;
  provinceIds?: string[];
  page?: number;
  limit?: number;
  enabled?: boolean;
}) {
  const restDataProviderClient = createRestDataProviderClient();

  const query = useQuery<{ data: Kh_Cities[] }>({
    queryKey: ["common-cities-", keyword, (provinceIds || [])?.join(","), limit, page],
    queryFn: () =>
      restDataProviderClient.custom({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/cities", toSnake({
          keyword,
          provinceIds,
          limit,
          page,
        })),
        method: "GET",
        options: {
          cache: "no-store",
        },
      }),
    enabled: enabled,
  });

  const refetch = () => {
    query.refetch();
  };

  return {
    isLoading: query.isLoading,
    cities: query.data?.data || [],
    query,
    refetch,
  };
}
